<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <router-link class="navbar-brand" to="/profile">Lihavapp</router-link>

        <ul class="navbar-nav ml-4">
          <router-link tag="li" class="nav-item" to="/waist">
            <a class="nav-link">Waist</a>
          </router-link>

          <router-link tag="li" class="nav-item" to="/weight">
            <a class="nav-link">Weight</a>
          </router-link>

          <router-link tag="li" class="nav-item" to="/blood-sugar">
            <a class="nav-link">Blood sugar</a>
          </router-link>          

          <router-link tag="li" class="nav-item" to="/blood-pressure">
            <a class="nav-link">Blood pressure</a>
          </router-link>                    
        </ul>

        <ul class="nav navbar-nav navbar-right ml-auto">
          <li class="nav-item">
            <a class="nav-link" href="#" role="button" v-on:click="logout()">Logout</a>
          </li>
        </ul>
      </div>
    </nav>

    <main id="main-container" class="container">
      <div id="alerts">
        <flash-message></flash-message>
      </div>
      <router-view v-if="store.dataFetched()" />
      <div v-else>
        <h2>Please wait while Lihavapp is fetching data from the server...</h2>
        <p>
          Weighing result data...
          <span v-if="store.state.dataState.weightData">OK</span>
        </p>
        <p>
          Scale data...
          <span v-if="store.state.dataState.scaleData">OK</span>
        </p>
        <p>
          Waist measurement data...
          <span v-if="store.state.dataState.waistData">OK</span>
        </p>

        <p>
          Blood sugar measurement data...
          <span v-if="store.state.dataState.bloodSugarData">OK</span>
        </p>

        <p>
          Blood pressure measurement data...
          <span v-if="store.state.dataState.bloodPressureData">OK</span>
        </p>        

      </div>
    </main>

    <footer id="main-footer">
      <div class="container">
        <router-link class="text-muted" to="/versionhistory">Lihavapp {{ APPLICATION_VERSION }}</router-link>

      </div>
    </footer>
  </div>
</template>

<script>
import { store } from "@/store.js";
export default {
  data: function() {
    return { store: store };
  },
  created: function() {
    this.store.fetchData();
  },
  methods: {
    logout: function(event) {
      this.flashSuccess("Logged out");
      this.$auth.logout();
      this.store.clear();
    }
  }
};
</script>


<style scoped>
#main-container {
  padding-top: 1em;
  margin-bottom: 120px;
  
}

#main-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px; /* Set the fixed height of the footer here */
  line-height: 60px; /* Vertically center the text there */
  background-color: #222;
}

#main-footer a {
  color: gray;
}
</style>
